module.exports = __webpack_public_path__ + "img/1280.a9c20b5d.svg";